/*
 * API and dependent servers actions
 */

// import axios from "axios";
import axios from "@/setup/axios-setup";

export async function checkAPIServer(context) {

  const { commit, dispatch } = context;

  try {
    const response = await axios.get(context.rootState.API_SERVER + "/health-check");
    // console.log("Server health", response);

    if (response.status.error) {
      commit("setError", response.status);
    } else {
      await dispatch("initUser", { invokeLocation: "ACTION (core/server) checkAPIServer" }, { root: true });
    }

  } catch (error) {
    if (error.isAxiosError) {
      // const e = error.toJSON();
      // console.error("Server Connection Error: ", e);
      commit("setError", {
        title: "Server connection error",
        text: "Please try again later",
        color: "danger"
      });
    }
  }
}
